var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "39px",
    viewBox: "0 0 46 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Settings&amp;Information/WarningAlert/Primary/48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings&Information/WarningAlert/Primary/48",
    transform: "translate(-1.000000, -4.500000)",
    fill: "#D62D14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,33.8421318 C22.5112071,33.8421318 21.4448399,34.8003024 21.4448399,36.2179035 C21.4448399,37.6379614 22.5112071,38.6256142 24,38.6256142 C25.4862171,38.6256142 26.5551601,37.6379614 26.5551601,36.2179035 C26.5551601,34.8003024 25.4862171,33.8421318 24,33.8421318 L24,33.8421318 Z M25.0998522,31.3140355 C25.3909138,28.3510772 25.939552,20.2361094 25.939552,17.9242157 L25.939552,16.6884213 L22.1222664,16.6884213 L22.1222664,17.9242157 C22.1222664,20.2361094 22.6734804,28.3510772 22.964542,31.3140355 L25.0998522,31.3140355 Z M24,4.5 C23.0830272,4.5 22.2356001,4.96925791 21.7822652,5.72842384 L1.33583263,39.854038 C0.885073532,40.6082903 0.887649299,41.5345219 1.34613569,42.2863172 C1.80462209,43.0381126 2.64432189,43.5 3.55614315,43.5 L44.4438569,43.5 C45.3556781,43.5 46.1953779,43.0381126 46.6538643,42.2863172 C47.1123507,41.5345219 47.1149265,40.6082903 46.6641674,39.854038 L26.2177348,5.72842384 C25.7643999,4.96925791 24.9169728,4.5 24,4.5 L24,4.5 Z M24,6.93719289 L44.4438569,41.0628071 L3.55614315,41.0628071 L24,6.93719289 L24,6.93719289 Z",
    id: "Warning"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/error-warning.ff3b461c706fd47d4d3a63b750cacaa5.svg";
export { ForwardRef as ReactComponent };